import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api/apiClient';

export interface StandingRecord {
  team_id: number;
  team_name: string | null;
  abbreviation: string | null;
  logo: string | null;
  color_primary: string | null;
  color_secondary: string | null;
  color_text: string | null;
  division_id: number | null;
  wins: number;
  losses: number;
  games_behind: string;
  pct: string;
  l10: string;
  strk: string;
}

/**
 * Fetch league standings with L10 and streak data from the API.
 * Returns an array of StandingRecord sorted by best record.
 */
export const useLeagueStandings = (leagueId: number | string | undefined, enabled = true) => {
  return useQuery<StandingRecord[]>({
    queryKey: ['leagueStandings', leagueId],
    queryFn: async () => {
      if (!leagueId) return [];
      const res = await apiClient.get(`/leagues/league-standings/${leagueId}`);
      return res.data;
    },
    enabled: !!leagueId && enabled,
    staleTime: 1000 * 60 * 5, // Fresh for 5 minutes
  });
};
